export default {"src":"/_next/static/media/hide-password.e98f98e7.svg","height":19,"width":24};